// extracted by mini-css-extract-plugin
export default {"circularProgress":"ButtonLoader_circularProgress__vCmVv","loader":"ButtonLoader_loader__l3GLp"};